<template>
  <vue-simplemde ref="editor" v-model="content" :configs="config" />
</template>

<script>
import VueSimplemde from "vue-simplemde";

export default {
  name: "FormMarkdown",
  props: {
    value: {
      type: String,
      default: "",
      required: true
    }
  },
  data: () => ({
    config: {
      toolbar: [
        "bold",
        "italic",
        "strikethrough",
        "|",
        "heading",
        "heading-smaller",
        "heading-bigger",
        "heading-1",
        "heading-2",
        "heading-3",
        "|",
        "unordered-list",
        "ordered-list",
        "quote",
        "|",
        "link",
        "image",
        "table",
        "horizontal-rule",
        "preview"
      ],
      spellChecker: false
    },
    content: ""
  }),
  components: {
    VueSimplemde
  },
  watch: {
    content: {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.$emit("input", newVal);
          this.$emit("change", newVal);
        }
      }
    },
    value: {
      immediate: true,
      handler(newVal) {
        const normalized = newVal || "";
        if (normalized !== this.content) {
          this.content = normalized;
        }
        this.syncEditorValue(normalized);
      }
    }
  },
  methods: {
    syncEditorValue(value) {
      this.$nextTick(() => {
        const editor = this.$refs.editor;
        if (!editor || !editor.simplemde) {
          return;
        }
        if (editor.simplemde.value() !== value) {
          editor.simplemde.value(value);
        }
      });
    }
  }
};
</script>

<style>
@import "~simplemde/dist/simplemde.min.css";
.editor-statusbar {
  display: none;
}

.CodeMirror {
  background: var(--dark-surface) !important;
  color: var(--text-color) !important;
}

.CodeMirror-cursor {
  border-left: 2px solid #000 !important;
}

body.backoffice-theme-dark .CodeMirror-cursor,
.v-application.theme--dark .CodeMirror-cursor {
  border-left-color: #fff !important;
}

.editor-toolbar a {
  background-color: var(--dark-surface) !important;
  color: var(--text-color) !important;
}
</style>
